export const setTimeFromSeconds = (time) => {
    const hours =  Math.floor(time / 60 / 60 % 60);
    const minutes = Math.floor(time / 60 % 60);
    const seconds = time % 60;
    return {hours, minutes, seconds};
};